/* Khaled bag (cart drawer). Opens after Add to cart (kw.js sends 'kw:cart') and from the bag icon.
   Contents come from the kw-cart section, rendered by Shopify on request, so they always match the live cart. */
(function () {
  'use strict';
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var bag, body, lastFocus, closeTimer;

  function find() {
    bag = document.getElementById('kw-bag');
    body = bag && bag.querySelector('[data-kw-bag-body]');
    return !!body;
  }
  function setCount(n) {
    document.querySelectorAll('[data-kw-count]').forEach(function (el) { el.textContent = n; el.hidden = !n; });
  }
  function render(html) {
    if (!html || !find()) return;
    var d = document.createElement('div');
    d.innerHTML = html;
    var inner = d.querySelector('.kw-bag__in');
    if (!inner) return;
    var had = document.activeElement && body.contains(document.activeElement) ? document.activeElement.getAttribute('data-kw-focus') : null;
    body.innerHTML = '';
    body.appendChild(inner);
    setCount(parseInt(inner.getAttribute('data-count'), 10) || 0);
    var x = body.querySelector('[data-kw-bag-close]');
    if (had === null && bag.classList.contains('is-open') && x && !body.contains(document.activeElement)) x.focus({ preventScroll: true });
  }
  function busy(on) { if (body) body.classList.toggle('is-busy', !!on); }
  function load() {
    busy(true);
    return fetch(root + '?sections=kw-cart', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (j) { render(j['kw-cart']); })
      .catch(function () {})
      .then(function () { busy(false); });
  }
  function post(path, data) {
    data.sections = 'kw-cart';
    busy(true);
    return fetch(root + path, { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify(data) })
      .then(function (r) { return r.json(); })
      .then(function (j) {
        if (j && j.sections && j.sections['kw-cart']) render(j.sections['kw-cart']); else return load();
      })
      .catch(function () { return load(); })
      .then(function () { busy(false); });
  }
  function open() {
    if (!find()) return false;
    clearTimeout(closeTimer);
    lastFocus = document.activeElement;
    bag.hidden = false;
    requestAnimationFrame(function () { requestAnimationFrame(function () { bag.classList.add('is-open'); }); });
    document.documentElement.style.overflow = 'hidden';
    var ic = document.querySelector('a.kw-ic--bag'); if (ic) ic.setAttribute('aria-expanded', 'true');
    return true;
  }
  function close() {
    if (!bag || bag.hidden) return;
    bag.classList.remove('is-open');
    document.documentElement.style.overflow = '';
    var ic = document.querySelector('a.kw-ic--bag'); if (ic) ic.setAttribute('aria-expanded', 'false');
    closeTimer = setTimeout(function () { bag.hidden = true; }, 420);
    if (lastFocus && lastFocus.focus) lastFocus.focus({ preventScroll: true });
  }

  document.addEventListener('click', function (e) {
    var t = e.target;
    if (t.closest('a.kw-ic--bag, [data-kw-bag-open]')) {
      if (e.metaKey || e.ctrlKey || e.shiftKey) return;
      if (!open()) return;
      e.preventDefault();
      load();
      return;
    }
    if (t.closest('[data-kw-bag-close]')) { close(); return; }
    var rm = t.closest('[data-kw-rm]');
    if (rm) { rm.disabled = true; post('cart/change.js', { id: rm.getAttribute('data-kw-rm'), quantity: 0 }); return; }
    var up = t.closest('[data-kw-upsell]');
    if (up) { up.disabled = true; up.textContent = 'Adding'; post('cart/add.js', { items: [{ id: parseInt(up.getAttribute('data-kw-upsell'), 10), quantity: 1 }] }); }
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && bag && !bag.hidden) { close(); return; }
    if (e.key !== 'Tab' || !bag || bag.hidden) return;
    var f = bag.querySelectorAll('a[href],button:not([disabled]),input:not([type=hidden])');
    if (!f.length) return;
    var first = f[0], last = f[f.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  });
  /* after Add to cart anywhere on the site */
  document.addEventListener('kw:cart', function () { if (open()) load(); });
})();
